// reworked and extended https://github.com/koleary94/Angular-2-Datepicker

import { animate, Component, ElementRef, EventEmitter, Input, keyframes, OnChanges,
         OnInit, Output, Renderer, SimpleChange, state, style, transition, trigger } from '@angular/core';

import * as moment from 'moment';
  
@Component({
  selector: 'datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  animations: [
    trigger('calendarAnimation', [
      transition('* => left', [
        animate(180, keyframes([
          style({ transform: 'translateX(105%)', offset: 0.5 }),
          style({ transform: 'translateX(-130%)', offset: 0.51 }),
          style({ transform: 'translateX(0)', offset: 1 })
        ]))
      ]),
      transition('* => right', [
        animate(180, keyframes([
          style({ transform: 'translateX(-105%)', offset: 0.5 }),
          style({ transform: 'translateX(130%)', offset: 0.51 }),
          style({ transform: 'translateX(0)', offset: 1 })
        ]))
      ])
    ])
  ]
})
export class DatepickerComponent implements OnInit, OnChanges {
    
    public timeMask = [ /[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/];

    private _time: string;
    get time(): string {
        return this._time;
    }
    set time(time: string) {
        this._time = time;

        this.date = this.applyTime(time, this.date || new Date());
    }
  
    @Output() dateChange = new EventEmitter<Date>();

    @Output() isValid: boolean;
  
    private _date: Date;
    @Input() get date(): Date { 
        return this._date; 
    };
    set date(date: Date) {
        this._date = date;
        this.isValid = !!this.date && this.isValidDay(this.date) && !!this.time;
        this.dateChange.emit(date);
    }

    @Input() disabled: boolean;
    @Input() dateFormat: string;
    @Input() timeFormat: string;
    @Input() rangeStart: Date;
    @Input() rangeEnd: Date;
    
    @Input() datePlaceholder: string = '';
    @Input() timePlaceholder: string = '';
    @Input() inputText: string;

    @Input() showCalendar: boolean;

    @Output() onSelect = new EventEmitter<Date>();

    @Input() calendarDays: Array<number>;
    @Input() currentMonth: string;
    @Input() dayNames: Array<String>;
    @Input() hoveredDay: Date;

    calendar: Calendar;
    currentMonthNumber: number;
    currentYear: number;
    months: Array<string>;
    animate: string;
    clickListener: Function;
  
    constructor(private renderer: Renderer, private elementRef: ElementRef) {
        this.dateFormat = 'YYYY-MM-DD';
        this.timeFormat = 'HH:mm';

        this.showCalendar = false;
        this.calendar = new Calendar(1);
        this.dayNames = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
        this.months = [
            'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль',
            'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
        ];
        this.clickListener = renderer.listenGlobal('document', 'click', (event: MouseEvent) => this.handleGlobalClick(event));
        }
  
    ngOnInit() {
        this.setDate();        
        this.setTime();
    }
    ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
        if ((changes['date'] || changes['dateFormat'])) {
            this.setDate();
        }
    }
    ngOnDestroy() {
        this.clickListener();
    }

    closeCalendar(): void {
        if (!this.showCalendar) return;

        this.showCalendar = false;
        this.setDate();
    }
  
    private setCurrentValues(date: Date) {
        this.currentMonthNumber = date.getMonth();
        this.currentMonth = this.months[this.currentMonthNumber];
        this.currentYear = date.getFullYear();

        const calendarArray = this.calendar.monthDays(this.currentYear, this.currentMonthNumber);
        this.calendarDays = [].concat.apply([], calendarArray);
    }
  
    setDate(): void {
        if (this.date) {
            this.setInputText(this.date);
            this.setCurrentValues(this.date);
        }
        else {
            this.inputText = '';
            this.setCurrentValues(new Date());
        }
    }  
    setTime(): void {
        this.time = moment(this.date || new Date()).format(this.timeFormat);
    }
    applyTime(time: string, date: Date): Date {
        if (time) {
            const timeMoment = moment(time, this.timeFormat);
            return moment(date)
                    .hours(timeMoment.isValid() ? timeMoment.hours() : 0)
                    .minutes(timeMoment.isValid() ? timeMoment.minutes() : 0)
                    .seconds(0)
                    .toDate();
        }

        return date;
    }


    setCurrentMonth(monthNumber: number) {
      this.currentMonth = this.months[monthNumber];
      const calendarArray = this.calendar.monthDays(this.currentYear, this.currentMonthNumber);
      this.calendarDays = [].concat.apply([], calendarArray);
    }
    setInputText(date: Date): void {
        this.inputText = moment(date).format(this.dateFormat);
    }
  
    onArrowLeftClick(): void {
        const currentMonth: number = this.currentMonthNumber;
        let newYear: number = this.currentYear;
        let newMonth: number;
    
        if (currentMonth === 0) {
            newYear = this.currentYear - 1;
            newMonth = 11;
        } else {
            newMonth = currentMonth - 1;
        }
    
        this.currentYear = newYear;
        this.currentMonthNumber = newMonth;
        this.setCurrentMonth(newMonth);
        this.triggerAnimation('left');
    }  
    onArrowRightClick(): void {
        const currentMonth: number = this.currentMonthNumber;
        let newYear: number = this.currentYear;
        let newMonth: number;
    
        if (currentMonth === 11) {
            newYear = this.currentYear + 1;
            newMonth = 0;
        } else {
            newMonth = currentMonth + 1;
        }
    
        this.currentYear = newYear;
        this.currentMonthNumber = newMonth;
        this.setCurrentMonth(newMonth);
        this.triggerAnimation('right');
    }  
    onCancel(): void {
        this.closeCalendar();
    }  
    onInputClick(): void {
        this.showCalendar = !this.showCalendar;
    }
    onHoverDay(day: Date): void {
        if (day && !this.isValidDay(day)) return;
        
        this.hoveredDay = day;
    }
    onSelectDay(day: Date): void {
        if (!day) return;

        const newDate = this.applyTime(this.time, day);
        if (!this.isValidDay(newDate)) return;

        this.date = newDate;
        this.onSelect.emit(newDate);
        this.showCalendar = !this.showCalendar;
    }
  
    handleGlobalClick(event: MouseEvent): void {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.closeCalendar();
        }
    }
  
    isValidDay(day): boolean {
        return day != 0
            && (!this.rangeStart || moment(day).isSameOrAfter(this.rangeStart, 'days'))
            && (!this.rangeEnd || moment(day).isSameOrBefore(this.rangeEnd, 'days'));
    }  
    isChosenDay(day: Date): boolean {
        if (day) {
            return this.date ? day.toDateString() == this.date.toDateString() : false;
        } else {
            return false;
        }
    }  
    isCurrentDay(day: Date): boolean {
        if (day) {
            return day.toDateString() == new Date().toDateString();
        } else {
            return false;
        }
    }  
    isHoveredDay(day: Date): boolean {
        return this.hoveredDay ? this.hoveredDay == day && !this.isChosenDay(day) : false;
    }
  
    triggerAnimation(direction: string): void {
        this.animate = direction;
        setTimeout(() => this.animate = 'reset', 185);
    }
}
  
class Calendar {
    firstWeekDay: number;

    constructor(firstWeekDay = 0) {
        this.firstWeekDay = firstWeekDay; // 0 = Sunday
    }

    weekStartDate(date: any) {
        var startDate = new Date(date.getTime());
        while (startDate.getDay() !== this.firstWeekDay) {
            startDate.setDate(startDate.getDate() - 1);
        }
        return startDate;
    }

    monthDates(year: any, month: any, dayFormatter:any = null, weekFormatter:any = null) {
        if ((typeof year !== "number") || (year < 1970)) {
            throw ('year must be a number >= 1970');
        };
        if ((typeof month !== "number") || (month < 0) || (month > 11)) {
            throw ('month must be a number (Jan is 0)');
        };
        var weeks: Array<any> = [],
            week: Array<any> = [],
            i = 0,
            date = this.weekStartDate(new Date(year, month, 1));
        do {
            for (i=0; i<7; i++) {
                week.push(dayFormatter ? dayFormatter(date) : date);
                date = new Date(date.getTime());
                date.setDate(date.getDate() + 1);
            }
            weeks.push(weekFormatter ? weekFormatter(week) : week);
            week = [];
        } while ((date.getMonth()<=month) && (date.getFullYear()===year));
        return weeks;
    }

    monthDays(year: any, month: any) {
        var getDayOrZero = function getDayOrZero(date: any) {
            return date.getMonth() === month ? date : 0;
        };
        return this.monthDates(year, month, getDayOrZero);
    }

    monthText(year: any, month: any) {
        if (typeof year === "undefined") {
            var now = new Date();
            year = now.getFullYear();
            month = now.getMonth();
        };
        var getDayOrBlank = function getDayOrBlank(date: any) {
            var s = date.getMonth() === month ? date.getDate().toString() : "  ";
            while (s.length < 2) s = " "+s;
            return s;
        };
        var weeks = this.monthDates(year, month, getDayOrBlank,
            function (week: any) { return week.join(" ") });
        return weeks.join("\n");
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/datepicker.component.ts